// extracted by mini-css-extract-plugin
module.exports = {"statuses":"StockInfo_statuses__mNZiE","horizontal":"StockInfo_horizontal__yNUg8","vertical":"StockInfo_vertical__k_unb"};